import validator from "validator";
import { cloneDeep } from "lodash";

// Const
import { defaultAddDeviceState } from "./const";

// Controller
import controller from './controller';

class AddDeviceModel {
  static addDeviceState;

  static getAddDeviceState(deviceList, profileList, siteList) {
    const addDeviceState = cloneDeep(defaultAddDeviceState);

    addDeviceState.deviceUid.list = deviceList;
    addDeviceState.deviceUid.originList = deviceList;
    addDeviceState.site.originList = siteList.map(site => {
      return {
        ...site,
        isActive: false
      }
    });
    addDeviceState.profile.originList = profileList.map(profile => {
      return {
        ...profile, isActive: false
      };
    });

    return addDeviceState;
  }

  static changeDeviceUid(deviceUid, value, originDeviceUidList) {
    value = (value.replace(/-/g, '')).toUpperCase();

    deviceUid.value = value;
    deviceUid.list = originDeviceUidList.filter(item => item.uid.indexOf(value) > -1);
    deviceUid.dirty = true;
    deviceUid.valid = deviceUid.required && deviceUid.value.length === deviceUid.length;
  }

  static initSite(site, restrictCountryCode) {
    site.list = [];
    site.restrictCountryCode = restrictCountryCode;

    if (!restrictCountryCode) {
      site.list = cloneDeep(site.originList);
    } else {
      for (const item of site.originList) {
        item.restrictCountryCode === restrictCountryCode && site.list.push(cloneDeep(item));
      }
    }

    if (site.list.length > 0) {
      site.list[0].isActive = true;
      site.selected = site.list[0];
    }
  }

  static initProfile = (profile, modelName) => {
    profile.list = [];
    for (const item of profile.originList) {
      item.deviceModel === modelName && profile.list.push(cloneDeep(item));
    }

    if (profile.list.length > 0) {
      profile.list[0].isActive = true;
      profile.selected = profile.list[0];
    }
  }

  static initLicenseKeyList = (licenseKeyList, defaultLicense, licenseList) => {
    licenseKeyList.list = licenseList;
    licenseKeyList.defaultLicense = defaultLicense;
  }

  static changeDeviceName(deviceName, value) {
    deviceName.value = value;
    deviceName.dirty = true;

    if (!value) {
      deviceName.valid = true;
    }

    if (value && validator.isByteLength(value, { min: 1, max: 64 })) {
      deviceName.valid = true;
    }

    if (value && !validator.isByteLength(value, { min: 1, max: 64 })) {
      deviceName.valid = false;
    }
  }

  static changeSite(site, value) {
    for (const item of site.list) {
      item.isActive = false;
      if (item.id === value.id) {
        item.isActive = true;
        site.selected = item;
      }
    }
  }

  static changeProfile(profile, value) {
    for (const item of profile.list) {
      item.isActive = false;
      if (item.id === value.id) {
        item.isActive = true;
        profile.selected = item;
      }
    }
  }

  static addLicenseKey(licenseKeyList) {
    licenseKeyList.valueList.push({
      key: '',
      dirty: false,
      valid: false
    });
  }

  static removeLicenseKey(licenseKeyList, index) {
    licenseKeyList.valueList = licenseKeyList.valueList.filter((item, itemIndex) => itemIndex !== index);
  }

  static changeLicenseKey(licenseKeyList, index, value) {
    licenseKeyList.valueList[index].key = value;
    licenseKeyList.valueList[index].dirty = value.length > 0 || false;
    licenseKeyList.valueList[index].valid = controller.checkLicenseLength(value);
  }
}

export default AddDeviceModel;